import React from 'react';
import { Link } from 'react-router-dom';

const QuickActions = () => {
    return (
        <div style={{ marginBottom: '30px' }}>
            <h3 style={{ margin: '0 0 15px 0', fontSize: '16px', fontWeight: 'bold', color: '#1F1F1F' }}>QUICK ACTIONS</h3>

            {/* Primary Action - Heavy Gold */}
            <div style={{ marginBottom: '20px' }}>
                <Link to="/billing" className="btn-gold-heavy" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
                    + Create New Bill
                </Link>
            </div>

            {/* Secondary Actions - Neutral Grid */}
            <div className="quick-actions-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <Link to="/add-jewellery" className="btn-neutral" style={{ textAlign: 'center', textDecoration: 'none' }}>
                    + Jewellery
                </Link>
                <Link to="/customers" className="btn-neutral" style={{ textAlign: 'center', textDecoration: 'none' }}>
                    Customers
                </Link>
                <Link to="/billing/history" className="btn-neutral" style={{ textAlign: 'center', textDecoration: 'none' }}>
                    Bills
                </Link>
                <Link to="/live-gold-rate" className="btn-neutral" style={{ textAlign: 'center', textDecoration: 'none' }}>
                    Gold Rate
                </Link>
            </div>

            <style>{`
                .btn-text-action {
                    color: #555;
                    text-decoration: none;
                    font-size: 14px;
                    font-weight: 500;
                    padding: 5px 10px;
                    border-radius: 4px;
                    transition: background 0.2s;
                }
                .btn-text-action:hover {
                    background: #eee;
                    color: #000;
                }
             `}</style>
        </div>
    );
};

export default QuickActions;
